module.exports = __webpack_public_path__ + "static/media/slider_4_master_user_en.99643d94.svg";